import { useEffect, useState } from 'react';
import { QUIZ_PATH_LABEL } from '../constants/site';
import { getCachedQuizQr, preloadQuizQr } from '../utils/quizQr';
import { SHARE_CARD_FONT, cardPx } from '../utils/shareCardHelpers';

interface ShareCardQrCodeProps {
  accent: string;
  cardWidth?: number;
  compact?: boolean;
  surfaceBg?: string;
  surfaceBorder?: string;
  textMuted?: string;
  subtitle?: string;
}

export default function ShareCardQrCode({
  accent,
  cardWidth,
  compact = false,
  surfaceBg = 'rgba(0,0,0,0.24)',
  surfaceBorder,
  textMuted = '#e2e8f0',
  subtitle = 'Quét mã làm quiz ngay',
}: ShareCardQrCodeProps) {
  const [dataUrl, setDataUrl] = useState(getCachedQuizQr() ?? '');
  const scale = compact ? 0.88 : 1;
  const qrSize = cardPx(46 * scale, cardWidth);
  const px = (value: number) => cardPx(value * scale, cardWidth);

  useEffect(() => {
    if (dataUrl) return;
    preloadQuizQr().then(setDataUrl).catch(() => {});
  }, [dataUrl]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: px(10),
        padding: `${px(8)}px ${px(10)}px`,
        borderRadius: px(10),
        background: surfaceBg,
        border: `1px solid ${surfaceBorder ?? `${accent}55`}`,
        fontFamily: SHARE_CARD_FONT,
      }}
    >
      <div
        style={{
          flexShrink: 0,
          background: '#ffffff',
          padding: px(3),
          borderRadius: px(6),
          lineHeight: 0,
        }}
      >
        {dataUrl ? (
          <img
            data-share-qr
            src={dataUrl}
            alt=""
            width={qrSize}
            height={qrSize}
            style={{ display: 'block' }}
          />
        ) : (
          <div
            style={{
              width: qrSize,
              height: qrSize,
              borderRadius: px(4),
              background: 'rgba(0,0,0,0.06)',
            }}
          />
        )}
      </div>
      <div style={{ textAlign: 'left', minWidth: 0 }}>
        <div
          style={{
            fontSize: px(10),
            color: accent,
            fontWeight: 700,
            letterSpacing: '0.02em',
            lineHeight: 1.3,
          }}
        >
          {QUIZ_PATH_LABEL}
        </div>
        <div
          style={{
            fontSize: px(8),
            color: textMuted,
            marginTop: px(2),
            lineHeight: 1.35,
          }}
        >
          {subtitle}
        </div>
      </div>
    </div>
  );
}